import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';
import i18n from '../../translations/i18n';

const EnumSelectFilterField = props => (
  <SelectField
    fullWidth
    value={props.filter ? props.filter.value : ''}
    onChange={(event, index, value) => props.onFilterChange(value)}
  >
    <MenuItem value="" primaryText="All" />
    {props.values.map(key => <MenuItem key={key} value={key} primaryText={props.t(`${key}`)} />)}
  </SelectField>
);

const extended = translate(['translations'], { i18n })(EnumSelectFilterField);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/filters/EnumSelectFilterField.js